module.exports = __webpack_public_path__ + "img/11.ab5664f5.png";